export default __webpack_public_path__ + "static/media/error_insurance.b489f77b.png";